<div fxLayoutAlign="space-apart center">
  <h2 class="nomargin" fxFlex>Properties</h2>
  <sbnb-button
    size="mini"
    [label]="saving ? 'Saving...' : 'Save'"
    [disabled]="saving"
    [loading]="saving"
    (clicked)="save()"></sbnb-button>
</div>

<sbnb-helptext-wrapper
  class="helptext-wrapper-type-content direct-site-edit"
  [area]="'content'"
  [pageId]="'direct-sites-properties-edit'"></sbnb-helptext-wrapper>

<mat-spinner *ngIf="properties.length === 0" class="loading-spinner" [diameter]="24"></mat-spinner>

<sbnb-direct-properties-selection
  *ngIf="properties.length > 0"
  [site]="directEditService.site"
  [properties]="properties"
  [futureProperties]="directEditService.site.include_future_properties"
  [selectedProperties]="directEditService.site.properties"
  (propertiesChange)="propertiesChange($event)"
  (futurePropertiesChange)="futurePropertiesChange($event)"></sbnb-direct-properties-selection>
